/** Absolute in-app URL to a board, for copy/share. */
export function buildBoardShareUrl(companyId: string, boardId: string): string {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/app/${encodeURIComponent(companyId)}/project-boards/${encodeURIComponent(boardId)}`;
}

/** Copy text to the clipboard, with a textarea fallback for older browsers. */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
